var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-item",on:{"click":function($event){return _vm.$emit('select')}}},[_c('span',{staticClass:"item",class:{
            bold: _vm.isPopularItem
          }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }